import { useQuery } from "@tanstack/react-query";

import type { ProfileInspectionsResult } from "../../models/Inspection";
import { getInspections } from "../../repositories/InspectionRepository";

interface UseInspectionsQueryProps {
	assetId: number;
	enabled?: boolean;
	onError?: (error: Error) => void;
}

export const useInspectionsQuery = ({
	assetId,
	enabled = true,
	onError,
}: UseInspectionsQueryProps) =>
	useQuery<ProfileInspectionsResult, Error>({
		queryKey: ["test-shack-inspections", assetId],
		meta: { realtime: ["DIM.GetProfileInspections"] },
		queryFn: ({ signal }) => getInspections({ assetId }, signal),
		enabled,
		onError,
	});
